// Pricing rules for the Day-to-Day Delivery service type.
export const DAY_TO_DAY_SERVICE_NAME = "Day-to-Day Delivery";
export const DAY_TO_DAY_MIN_BASE_PRICE = 5000;

export const formatNaira = (amount: number) => `₦${amount.toLocaleString("en-NG")}`;

/** Parses a typed or formatted amount ("6,000.00", "6000") into a number, or NaN. */
export const parseAmount = (value: string | number | null | undefined) =>
  parseFloat(String(value ?? "").replace(/,/g, ""));

/** Error message when a Day-to-Day base price is below the minimum, otherwise null. */
export const dayToDayPriceError = (value: string | number | null | undefined): string | null => {
  const amount = parseAmount(value);
  if (Number.isNaN(amount) || amount < DAY_TO_DAY_MIN_BASE_PRICE) {
    return `Day-to-Day Delivery base price must be at least ${formatNaira(DAY_TO_DAY_MIN_BASE_PRICE)}.`;
  }
  return null;
};
